import Sidebar from "../components/Sidebar";
import creator1Img from "../assets/images/creator1.png";
import Topbar from "../components/Topbar";
import { useEffect, useState } from "react";
import InvitationTable from "../components/InvitationTable";
import SelectList from "../components/SelectList";
import { API_BASE } from "../utils/Instance";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const messageOptions = [
  {
    label: "Select a message",
    value: "",
  },
  {
    label:
      "You’re perfect! You could retire if you joined Select Exposure!\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg1",
  },
  {
    label:
      "With your body, you could make millions on Select Exposure!\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg2",
  },
  {
    label:
      "You have the world’s BEST butt! You’d crush it on Select Exposure.\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg3",
  },
  {
    label:
      "You have the cutest feet! You should enter them into Select Exposure Contests.\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg4",
  },
  {
    label:
      "You have a great body! You should show it off on Select Exposure.\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg5",
  },
  {
    label:
      "A Select Exposure User has nominated your Legs for an online Hot Body Contest.\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg6",
  },
  {
    label:
      "A Select Exposure User has nominated your Chest & Stomach for an online Hot Body Contest.\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg7",
  },
  {
    label:
      "A Select Exposure User has nominated your Butt for an online Hot Body Contest.\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg8",
  },
  {
    label:
      "A Select Exposure User has nominated your Feet for an online Hot Body Contest.\nJoin now to start winning contests: https://selectexposure.com/join. Reply STOP to opt out of SMS messages.",
    value: "msg9",
  },
];


export default function InviteCreators() {
  const [message, setMessage] = useState(messageOptions[0]);
  const [invitations, setInvitations] = useState([]);

  const [activeTab, setActiveTab] = useState("email");
  const [emailAddress, setEmailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [agreeTos, setAgreeTos] = useState(false);
  const [agreeTosPhone, setAgreeTosPhone] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { profile } = useAuth();

  // Load invitation history from backend (List Smoke Signals)
  useEffect(() => {
    fetchInvitationHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchInvitationHistory = async () => {
    try {
      const url = `${API_BASE}accounts/smoke-signals/`;
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${profile?.accessToken}`,
        },
      });

      if (!resp.ok) {
        const text = await resp.text();
        console.error("History fetch failed:", resp.status, text);
        throw new Error("Failed to load invitation history");
      }

      const data = await resp.json();
      // API format could be array or an object with results
      const items = Array.isArray(data) ? data : (data.results || data.smoke_signals || []);

      const mapped = items.map((s, i) => {
        // Backend fields: { id, sender, recipient, channel, status, timestamp, message }
        const target = s.recipient || s.to || s.email || s.phone || "N/A";
        const channel = s.channel || s.method || "N/A"; // EMAIL | SMS
        const status = s.status || s.joining_status || "Pending"; // Delivered/Failed/Pending
        const created = s.timestamp || s.sent_at || s.created_at || s.date || new Date().toISOString();

        return {
          id: s.id || `hist-${i}`,
          email: target,
          method: channel === "EMAIL" ? "Email" : channel === "SMS" ? "SMS" : channel || "N/A",
          date: new Date(created).toISOString().split("T")[0],
          joining_status: status,
        };
      });

      setInvitations(mapped);
    } catch (e) {
      console.error("Error loading invitation history:", e);
    }
  };

  const handleSend = () => {
    // Validate inputs before showing modal
    if (activeTab === "email" && !emailAddress) {
      toast.error("Please enter an email address");
      return;
    }
    if (activeTab === "sms" && !phoneNumber) {
      toast.error("Please enter a phone number");
      return;
    }
    if (activeTab === "email" && !agreeTos) {
      toast.error("Please agree to the Smoke Signal Terms of Service");
      return;
    }
    if (activeTab === "sms" && !agreeTosPhone) {
      toast.error("Please agree to the Smoke Signal Terms of Service");
      return;
    }
    if (!message || !message.value) {
      toast.error("Please select a message");
      return;
    }
    setShowConfirmModal(true);
  };

  const confirmSend = async () => {
    setShowConfirmModal(false);
    setLoading(true);

    try {
      const payload = {
        to: activeTab === "email" ? emailAddress : phoneNumber,
        channel: activeTab === "email" ? "EMAIL" : "SMS",
        message: message.label, // The full message text
        sender: profile?.screenName || profile?.screen_name || "User"
      };

      console.log("Sending smoke signal payload:", payload);

      const response = await fetch(`${API_BASE}accounts/smoke-signals/send/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${profile?.accessToken}`
        },
        body: JSON.stringify(payload)
      });

      console.log(`Response status:`, response.status);

      if (!response.ok) {
        let errorData;
        const contentType = response.headers.get("content-type");
        
        if (contentType && contentType.includes("application/json")) {
          errorData = await response.json();
        } else {
          const textData = await response.text();
          console.error("Non-JSON response:", textData);
          throw new Error("Server returned an invalid response. The smoke signal endpoint may not be properly configured.");
        }
        
        throw new Error(errorData.message || errorData.error || "Failed to send smoke signal");
      }

      const data = await response.json();
      console.log("Smoke signal sent successfully:", data);

      toast.success(`Smoke signal sent successfully via ${activeTab === "email" ? "Email" : "SMS"}!`);
      
      // Refresh history from backend so table stays in sync
      fetchInvitationHistory();
      
      // Clear form
      if (activeTab === "email") {
        setEmailAddress("");
        setAgreeTos(false);
      } else {
        setPhoneNumber("");
        setAgreeTosPhone(false);
      }
      setMessage(messageOptions[0]);

    } catch (error) {
      console.error("Error sending smoke signal:", error);
      toast.error(error.message || "Failed to send smoke signal. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-black">
      <Sidebar />
      <div className="flex-1 p-4 md:p-6 lg:ml-64 w-full">
        <Topbar pageTitle="Send a Smoke Signal" />

        <div className="mx-auto p-2 md:p-6 w-full">
          <h1 className="text-xl md:text-2xl font-semibold mb-2 md:mb-4 font-inter text-white flex items-center gap-2">
            Know a smoke that should be on Select Exposure?
          </h1>

          <p className="text-gray-700 mb-4 md:mb-8 text-white text-sm md:text-base">
            Answer: Yes! We all know a smoke we'd like to see strip down – It
            could be a classmate, co-worker, neighbor, friend, even a teacher or
            nurse. Use Smoke Signal to send an <span className="underline">anonymous</span> invite to join Select
            Exposure. Your secret is safe with us! <strong>We’ll even use the email address or phone number you provide to let you know if your smoke joins Select Exposure.</strong>
          </p>

          <div className="bg-[#1C1C1E] rounded-lg shadow-md p-3 md:p-6 mb-4 md:mb-6">
            <div className="border-b mb-4 md:mb-6">
              <div className="flex">
                <button
                  className={`pb-2 mr-4 font-medium text-sm md:text-base ${
                    activeTab === "email"
                      ? "border-b-2 border-[#ceb46a] text-[#ceb46a]"
                      : "text-gray-600"
                  }`}
                  onClick={() => setActiveTab("email")}
                >
                  Invite via Email
                </button>
                <button
                  className={`pb-2 font-medium text-sm md:text-base ${
                    activeTab === "sms"
                      ? "border-b-2 border-[#ceb46a] text-[#ceb46a]"
                      : "text-gray-600"
                  }`}
                  onClick={() => setActiveTab("sms")}
                >
                  Invite via SMS
                </button>
              </div>
            </div>

            <div className="mb-4">
              <SelectList
                label="Choose An Invite Message:"
                options={messageOptions}
                value={message}
                onChange={setMessage}
                placeholder="Select a message"
              />
            </div>

            {activeTab === "email" && (
              <div className="mb-4">
                <label className="block text-white font-medium mb-2 text-sm md:text-base">
                  Enter Email Address:
                </label>
                <input
                  type="email"
                  className="w-full p-2 md:p-3 text-[#667080] border border-[#ceb46a] bg-transparent placeholder-[#667080] rounded-lg text-sm md:text-base"
                  placeholder="Enter email address"
                  value={emailAddress}
                  onChange={(e) => setEmailAddress(e.target.value)}
                />
              </div>
            )}

            {activeTab === "sms" && (
              <div className="mb-4">
                <label className="block text-white font-medium mb-2 text-sm md:text-base">
                  Enter Phone Number:
                </label>
                <input
                  type="tel"
                  className="w-full p-2 md:p-3 text-[#667080] border border-[#ceb46a] bg-transparent placeholder-[#667080] rounded-lg text-sm md:text-base"
                  placeholder="Enter phone number (e.g., +1234567890)"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
            )}

            <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
              <div>
                {activeTab === "email" ? (
                  <div className="flex items-center gap-2 text-white text-sm">
                    <input
                      id="agreeTos"
                      type="checkbox"
                      className="accent-[#ceb46a]"
                      checked={agreeTos}
                      onChange={(e) => setAgreeTos(e.target.checked)}
                    />
                    <label htmlFor="agreeTos">
                      I agree to the <a href="/terms" className="underline text-[#ceb46a]">Smoke Signal Terms of Service</a>
                    </label>
                  </div>
                ) : (
                  <div className="flex items-center gap-2 text-white text-sm">
                    <input
                      id="agreeTosPhone"
                      type="checkbox"
                      className="accent-[#ceb46a]"
                      checked={agreeTosPhone}
                      onChange={(e) => setAgreeTosPhone(e.target.checked)}
                    />
                    <label htmlFor="agreeTosPhone">
                      I agree to the <a href="/terms" className="underline text-[#ceb46a]">Smoke Signal Terms of Service</a>
                    </label>
                  </div>
                )}
                <p className="mt-1 max-w-md text-sm leading-tight text-white">
                  *By inviting someone via SMS, you confirm they have
                  <br />
                  agreed to receive a message from Select Exposure.
                  <br />
                  Message &amp; data rates may apply. Reply STOP to opt
                  <br />
                  out.
                </p>
              </div>

              <div className="flex justify-end gap-2 md:gap-4">
                <button className="px-4 md:px-8 py-2 md:py-3 border border-[#ceb46a] text-[#ceb46a] font-medium rounded-lg text-sm md:text-base">
                  Cancel
                </button>
                <button
                  onClick={handleSend}
                  className="px-4 md:px-8 py-2 md:py-3 bg-[#ceb46a] text-black font-medium rounded-lg text-sm md:text-base flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={
                    loading ||
                    (activeTab === "email" && (!agreeTos || !emailAddress)) ||
                    (activeTab === "sms" && (!agreeTosPhone || !phoneNumber)) ||
                    !message?.value
                  }
                >
                  <span className="bg-black text-[#ceb46a] text-xm font-bold px-2 py-1 rounded-full">$1</span>
                  {loading ? "Sending..." : "Send Invite"}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="py-4 md:py-10 overflow-x-auto">
          <InvitationTable
            data={invitations}
            onDelete={async (id) => {
              try {
                const url = `${API_BASE}accounts/smoke-signals/${id}/`;
                const resp = await fetch(url, {
                  method: "DELETE",
                  headers: {
                    "Authorization": `Bearer ${profile?.accessToken}`,
                  },
                });
                if (!resp.ok) {
                  const text = await resp.text();
                  console.error("Delete failed:", resp.status, text);
                  throw new Error("Failed to delete invitation");
                }
                // Refresh list after delete
                fetchInvitationHistory();
              } catch (e) {
                console.error("Error deleting invitation:", e);
                alert("Failed to delete the invitation. Please try again.");
              }
            }}
          />
        </div>
      </div>

      {showConfirmModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex items-center justify-center">
          <div className="bg-[#1C1C1E] text-white p-6 rounded-lg max-w-sm w-full mx-4">
            <h2 className="text-xl font-bold mb-4 text-[#ceb46a]">Confirm Invite</h2>
            <p className="mb-6">
              Are you sure you want to send this Smoke Signal invite via <strong>{activeTab === "email" ? "Email" : "SMS"}</strong> to <strong>{activeTab === "email" ? emailAddress : phoneNumber}</strong>? This will cost $1.
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowConfirmModal(false)}
                className="border border-[#ceb46a] px-4 py-2 rounded text-[#ceb46a]"
              >
                Cancel
              </button>
              <button
                onClick={confirmSend}
                className="bg-[#ceb46a] text-black px-4 py-2 rounded font-semibold"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
